import { FacilityUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/facility_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

type FacilityUpdatedDetailProps = {
  event: FacilityUpdatedEvent;
};

export const FacilityUpdatedDetail = ({
  event,
}: FacilityUpdatedDetailProps) => {
  const previous = event.previousFacility;
  const current = event.updatedFacility;

  if (!previous || !current) {
    return (
      <Col className="@FacilityUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'facilityName',
      label: 'Name',
      previous: previous.facilityName,
      current: current.facilityName,
    },
    {
      field: 'facilityType',
      label: 'Type',
      previous: previous.facilityType,
      current: current.facilityType,
    },
    {
      field: 'timezone',
      label: 'Timezone',
      previous: previous.timezone?.name,
      current: current.timezone?.name,
    },
    {
      field: 'facilityGroupId',
      label: 'Facility Group ID',
      previous: previous.facilityGroupId?.value,
      current: current.facilityGroupId?.value,
    },
    {
      field: 'streetAddress',
      label: 'Street Address',
      previous: previous.address?.streetAddress,
      current: current.address?.streetAddress,
    },
    {
      field: 'city',
      label: 'City',
      previous: previous.address?.city,
      current: current.address?.city,
    },
    {
      field: 'state',
      label: 'State',
      previous: previous.address?.state,
      current: current.address?.state,
    },
    {
      field: 'country',
      label: 'Country',
      previous: previous.address?.country,
      current: current.address?.country,
    },
    {
      field: 'postalCode',
      label: 'Postal Code',
      previous: previous.address?.postalCode,
      current: current.address?.postalCode,
    },
  ];

  return (
    <Col className="@FacilityUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Facility</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Name" value={current.facilityName} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
